import { useMutation, useQueryClient } from '@tanstack/react-query';
import { keys } from '@/lib/queryKeys';
import { createPurchaseOrder } from './api';
import type { NewPurchaseOrderInput } from './types';

export function useCreatePurchaseOrder() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: NewPurchaseOrderInput) => createPurchaseOrder(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.procurement.purchaseOrders() });
    },
  });
}
